package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.react.StyleUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{div, style, table, tbody, td, tr}

/**
 * The column of transcript names that label the transcripts, which appears to the
 * left of the transcripts.
 */
@react
object TranscriptLabelColumn {
	case class Props
	(
		labels: Seq[String],
		heightPixels: Int
	)

	val component = FunctionalComponent[Props] { props =>
		div(
			style := StyleUtil.makeStyle(
				("height", s"${props.heightPixels}px"),
				("display", "table"),
				("paddingRight", "10px")
			)
		)(
			div(
				style := StyleUtil.makeStyle(
					("height", "100%"),
					("display", "table-cell"),
					("verticalAlign", "bottom")
				)
			)(
				props.labels map { label =>
					div(
						style := StyleUtil.makeStyle(
							("height", "20px"),
							("textAlign", "center"),
							("whiteSpace", "nowrap"),
							("marginBottom", "5px")
						)
					)(
						label
					)
				}
			)
		)
	}
}
